<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M12.5 21.9998C17.7467 21.9998 22 17.7466 22 12.5C22 7.25336 17.7467 3.00012 12.5 3.00012C7.25329 3.00012 3 7.25336 3 12.5C3 17.7466 7.25329 21.9998 12.5 21.9998Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 7.00012V13.7501L16 16.0001"
      stroke="currentColor"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
  </svg>
</template>
